/* eslint-disable no-undef */

/** DEV OPTS*/
/* @flow */

/* eslint-env node*/
/* eslint-disable no-console */
/*
 * Coach Amigo React Native App
 * https://github.com/facebook/react-native
 *
 */

export const DEV = globalThis && globalThis.DEV;
export const API_DEBUG = false;
export const APP_VERSION = '1.0.2';
export const APP_ID = '100002';
export const WP_API_VERSION = 'v1';
export const WP_API_ROOT = globalThis.api_root + WP_API_VERSION+'/';
export const MAX_API_TIMEOUT = 30;